<div class="url-wrapper">
  <a
    href="https://apps.apple.com/ph/app/payments-manager/id1638315322"
    target="_blank"
  >
    <span style="display: none;">App Store</span>
    <img role="img" class="background-image-link" src="assets/images/auth/app-store-badge.svg" alt="App Store"/>
  </a>
</div>